import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.js'
import './index.css' // 💡 이 부분에서 스타일 시트가 명확히 로드되어야 합니다.

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)